var CropperDrawSettings = (function () {
    function CropperDrawSettings() {
        this.strokeWidth = 1;
        this.strokeColor = 'rgba(255,255,255,1)';
        this.dragIconStrokeWidth = 1;
        this.dragIconStrokeColor = 'rgba(0,0,0,1)';
        this.dragIconFillColor = 'rgba(255,255,255,1)';
    }
    return CropperDrawSettings;
}());
export { CropperDrawSettings };
//# sourceMappingURL=cropperDrawSettings.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/src/cropperDrawSettings.js
// module id = 621
// module chunks = 10